<template>
  <v-layout 
    v-if="activities"
    wrap 
    class="activity-page"
    :style=" { width: width,   padding: `0 ${isShow ? 30 : 20}px` }"
  >
    <v-flex xs12 class="header"
      :style="{   height: `${isShow ? 60 : 100}px`, padding: `${isShow ? 20 : 40}px 10px ${isShow ? 10 : 30}px 10px` }"
    >
      <!--span :style="{ color: color2 }">{{ titleDate }}</span><span :style="{ color: color1 }"> - {{ titleInfo }}</span-->
      <span :style="{ color: colorTitle }">{{ titleDate }}</span><span :style="{ color: color1 }"></span>
    </v-flex>
    <v-flex
      xs12
      v-for="(activityItem, index) of activities"
      :key="index"
      style="padding: 10px;"
    >
      <activity-item-banner
        :data="activityItem"
        :color1="color1"
        :color2="color2"
        :color3="color3"
        :color4="color4"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import utils from '@/services/utils'
import ActivityItemBanner from '../activityItemBanner/Index'
export default {
  name: 'ActivityPageBanner',
  components: {
    ActivityItemBanner,
  },
  props: {
    titleDate: {
      type: String,
      default: null
    },
    titleInfo: {
      type: String,
      default: null
    },
    activities: {
      type: Array,
      default: null
    },
    cols: {
      type: Number,
      default: 2
    },
    color1: {
      type: String,
      default: '#02443C'
    },
    color2: {
      type: String,
      default: '#BF9D5A'
    },
    color3: {
      type: String,
      default: '#BF9D5A'
    },
    color4: {
      type: String,
      default: '#BF9D5A'
    },
    width: {
      type: Number,
      default: 1920,
    },
  },
  data: () => ({
  }),
  computed: {
    display () {
      return `xs12`
    },
    colorTitle () {
      return utils.getParameterByName('colortitle') ? '#'.concat(utils.getParameterByName('colortitle')) : this.color2
    },
    isShow () {
      const aux = utils.getParameterByName('show')
      return aux ? true : false
    },
  },
}
</script>

<style scoped>
.activity-page {
  margin: 0;
}

.header {
  font-size: 30px;
  line-height: 40px;
  font-weight: 500;
}
</style>

